import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'num'
})
export class NumPipe implements PipeTransform {

  transform(value: any, num: any): any {
    let ret = 0;

    if (num > 0)
      ret = Math.ceil(value / Math.abs(num)) * Math.abs(num);
    else
      ret = Math.floor(value / Math.abs(num)) * Math.abs(num);

    if (ret == value) {
      if (num > 0)
        ret += Math.abs(num);
      else
        ret -= Math.abs(num);
    }

    if (ret <= value + 3) {
      if (num > 0)
        ret += Math.abs(num);
    }

    if (ret >= value - 3) {
      if (num < 0)
        ret -= Math.abs(num);
    }

    ret = ret == 0 ? 1 : ret;

    return ret;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/num.pipe.ts